export default __webpack_public_path__ + "static/media/HYPERLINK.631df2c1.svg";